<template>
    <gofix-card fullContent class="mb-0">
        <div class="px-4 py-3">
            <gofix-button :label="!item ? 'Add' : 'Edit'" @click="openModalItem"></gofix-button>
        </div>
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:weightage" slot-scope="row">
                {{ row.item.weightage ? `${row.item.weightage}%` : '0%' }}
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
                <b-form class="formV2">
                    <gofix-form-input-number
                        label="	Data from IEMS"
                        v-model="modal.data.data_from_iems"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                    <gofix-form-input-number
                        label="Feedback from RC"
                        v-model="modal.data.feedback_from_rc"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                    <gofix-form-input-number
                        label="Feedback from Social Media"
                        v-model="modal.data.feedback_from_sm"
                        :integer-limit="3"
                        suffix="%">
                    </gofix-form-input-number>
                </b-form>
                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
    </gofix-card>
</template>
<script>
export default {
    name: 'performance_assesment_other_sources_weightage',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        return {
            tableConfig:{
                name: 'performance-assesment-other-sources-weightage',
                controls:{
                    create: false,
                    update: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    reload: false,
                    tablePagination: false,
                    tableFilter: false
                },
                filter: {
                    contract_id: {type: "number", value: null, function:"=", with: []},
                    property_type: {type: "text", value: "", function:"ilike", with: []},
                },
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "id",
                sortDirection: "asc",
                fields: [
                    {
                        key: 'id',
                        label: 'No',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:100px",
                        sorting: false,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'sources_description',
                        label: 'Other sources description',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:300px",
                        sorting: false,
                    },
                    {
                        key: 'weightage',
                        label: 'Weightage (%)',
                        isActive: 1,
                        isFilter: false,
                        sorting: false,
                    },
                ]
            },
            tableItems: [],
            item: null,
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                options: {
                    sources: ['Data from IEMS', 'Feedback from RC', 'Feedback from Social Media']
                },
                data: {
                    contract_id: null,
                    property_type: null,
                    data_from_iems: null,
                    feedback_from_rc: null,
                    feedback_from_sm: null,
                }
            },
            timer: {
                save: null
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve,reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value = this.contract.id
            tableRequest.type_setting = 'pa_other_weight_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                let arrTmp = [];
                this.item = null;
                if(response.items.length) {
                    this.item = response.items[0]
                    let index = 1;
                    for (const [key, value] of Object.entries(response.items[0])) {
                        if(['data_from_iems', 'feedback_from_rc', 'feedback_from_sm'].includes(key)) {
                            let name = 'Data from IEMS'
                            if(key == 'feedback_from_rc') name = 'Feedback from RC'
                            if(key == 'feedback_from_sm') name = 'Feedback from Social Media'
                            arrTmp.push({
                                id: index,
                                sources_description: name,
                                weightage: value,
                            })
                            index++;
                        }
                    }
                }
                this.tableItems = arrTmp;
                this.tableConfig.total = arrTmp.length;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the other sources weightage", "danger");
                reject();
            })
        },
        async openModalItem(item){
            if(this.item){
                this.modal.title = 'Edit Other Sources Weightage'
                this.modal.data = Object.assign(this.modal.data, this.item)
            } else {
                if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");
                this.modal.title = 'Create Other Sources Weightage'
                this.modal.data = {
                    contract_id: this.contract.id,
                    property_type: this.propertyType,
                    data_from_iems: null,
                    feedback_from_rc: null,
                    feedback_from_sm: null,
                }
            }

            this.modal.open = true;
        },
        saveItem() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(() => {
                if(!this.modal.data.data_from_iems) return this.$alertNotification("Inspection by property officers is required", "danger")
                if(!this.modal.data.feedback_from_rc) return this.$alertNotification("Maintenance regime is required", "danger")
                if(!this.modal.data.feedback_from_sm) return this.$alertNotification("Other sources is required", "danger")

                const request = {
                    id: this.modal.data.id || null,
                    property_type: this.modal.data.property_type,
                    contract_id: this.modal.data.contract_id,
                    data_from_iems: this.$accounting.unformat(this.modal.data.data_from_iems),
                    feedback_from_rc: this.$accounting.unformat(this.modal.data.feedback_from_rc),
                    feedback_from_sm: this.$accounting.unformat(this.modal.data.feedback_from_sm),
                    type_setting: 'pa_other_weight_setting'
                }

                const total = Number(request.data_from_iems) + Number(request.feedback_from_rc) + Number(request.feedback_from_sm);
                if(total > 100) {
                    return this.$alertNotification("Total weightage must be less than or equal to 100%", "danger")
                }

                if(this.modal.loading) return
                this.modal.loading = true

                this.$store.dispatch(`PerformanceAssesmentSettingsController/savePASettings`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(!request.id ? 'adding' : 'editing', 'pa_maintenance_weight'));
                    })
                    .catch(err => {
                        console.log(err)
                        this.modal.loading = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
            }, 200)
        }
    }
}
</script>